import BackendService from './BackendService';

async function getKitchens(params = {}) {
  return BackendService.getData('/kitchens/', {}, params);
}

async function createKitchen(data) {
  return BackendService.postData('/kitchens/', data);
}

async function updateKitchen(id, data) {
  return BackendService.patch(`/kitchens/${id}/`, data);
}

async function deleteKitchen(id) {
  return BackendService.destroy(`/kitchens/${id}/`);
}

const KitchenService = {
  getKitchens,
  createKitchen,
  updateKitchen,
  deleteKitchen,
};

export default KitchenService;
